import { h } from "preact";
import { useRef } from "preact/hooks";
import classname from "../../foundation/utils/classname";
import { copyContent } from "../../foundation/utils/platform_ts";
import showToast from "../../foundation/utils/showToast";
import IconCopy from "../Icons/IconCopy";

import styles from "./InfoCopy.module.css";

interface Props {
    info: string;
    class?: string;
}

function InfoCopy({
    info,
    class: className
}: Props) {
    const copyButtonRef = useRef<HTMLDivElement>(null);

    function handleCopyClick() {
        copyContent({
            content: info
        });
        showToast({
            text: "Copied to clipboard",
            container: copyButtonRef.current,
            source: `copyButtonWrapper`
        });
    }
    return (
        <div class={classname(styles.infoCopy, className)}>
            <span class={classname(styles.info, "ellipsis", "noSelect")}>
                {info}
            </span>
            <div
                class={styles.copyButtonWrapper}
                ref={copyButtonRef}
                onClick={handleCopyClick}>
                <IconCopy/>
            </div>
        </div>
    );
}

export default InfoCopy;
